import { Checkbox, FormControl, FormControlLabel, Tooltip } from "@mui/material";
import { ExportFieldsets } from "misc/exportFieldsets";
import { ChangeEvent, Fragment } from "react";
import { useTranslate } from "react-admin";

type CheckboxGroupsPropsType = {
  groupsData: ExportFieldsets | null;
  handleClickGroup: (groupName: string) => (e: ChangeEvent<HTMLInputElement>) => void;
  handleClickChild: (key: string, groupName: string) => (e: ChangeEvent<HTMLInputElement>) => void;
};

export default function CheckboxGroups(props: CheckboxGroupsPropsType) {
  const { groupsData, handleClickGroup, handleClickChild } = props;
  const translate = useTranslate();

  if (!groupsData) return null;

  function groupIsChecked(groupName: string) {
    if (!groupsData) return false;
    const fieldset = groupsData[groupName];
    return fieldset ? fieldset.isChecked : false;
  }

  function childIsChecked(childName: string, groupName: string) {
    if (!groupsData) return false;
    const fieldset = groupsData[groupName];
    if (!fieldset) return false;
    const field = fieldset.fields[childName];
    if (!field) return false;
    return field.isChecked;
  }

  return (
    <Fragment>
      {Object.keys(groupsData).map((groupName) => {
        const fieldset = groupsData[groupName];
        if (!fieldset) return null;
        const fields = fieldset.fields;

        return (
          <FormControl key={groupName} sx={{ width: "30%", mb: 4 }} component="fieldset" margin="dense">
            <FormControlLabel
              label={translate(groupName, 1)}
              sx={{ "> .MuiFormControlLabel-label": { fontWeight: "bold" } }}
              control={
                <Checkbox
                  checked={groupIsChecked(groupName)}
                  color="primary"
                  onChange={handleClickGroup(groupName)}
                  value={groupName}
                />
              }
            />

            {Object.keys(fields).map((key) => {
              const field = fields[key];
              if (!field) return null;
              const label = (
                <Tooltip arrow title={field.tooltip || ""}>
                  <span>{field.name}</span>
                </Tooltip>
              );

              return (
                <FormControlLabel
                  key={key}
                  label={label}
                  control={
                    <Checkbox
                      checked={childIsChecked(key, groupName)}
                      color="primary"
                      onChange={handleClickChild(key, groupName)}
                      value={key}
                    />
                  }
                />
              );
            })}
          </FormControl>
        );
      })}
    </Fragment>
  );
}
